import { render, staticRenderFns } from "./ChatMessages.vue?vue&type=template&id=4d5a5e00&scoped=true"
import script from "./ChatMessages.vue?vue&type=script&lang=js"
export * from "./ChatMessages.vue?vue&type=script&lang=js"
import style0 from "./ChatMessages.vue?vue&type=style&index=0&id=4d5a5e00&prod&scoped=true&lang=css"
import style1 from "./ChatMessages.vue?vue&type=style&index=1&id=4d5a5e00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_bddh7bz47tm4asog4nvkp26dru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5a5e00",
  null
  
)

export default component.exports